<!-- Error Views -->
<app-module-error class="flex-fill" *ngIf="noData" [noData]="true"></app-module-error>
<!-- Content -->
<div class="currentAgentStates h-100 d-flex flex-row flex-nowrap align-items-stretch" *ngIf="dataLoadSuccess && !noData">
    <cv-current-agent-states-pm-table class="equalFill" *ngIf="localizationsLoaded && !noData && getActiveView() !== 'chart'" 
        [moduleManager]="moduleManager" 
        [readOnly]="readOnly" 
        [sharedData]="sharedData" 
        [showFilter]="_filterBarShowing"
        [_stateToColorMap]="_stateToColorMap"
        [moduleKey]="moduleKey">
    </cv-current-agent-states-pm-table>
    <div class="view-divider m-2" *ngIf="localizationsLoaded && !noData && getActiveView() === 'dual'"></div>
    <cv-current-agent-states-pm-graph class="equalFill" *ngIf="localizationsLoaded && !noData && getActiveView() !== 'table'" 
        [readOnly]="readOnly" 
        [sharedData]="sharedData"
        [_stateToColorMap]="_stateToColorMap">
    </cv-current-agent-states-pm-graph>
    <div *ngIf="sharedData.IncompatibleSettings" class="incompatible-overlay position-absolute w-100 h-100 font-weight-bold" style="z-index: 2; background-color: rgba(0,0,0,0.80); top: 0; left: 0;">
        <div class="position-absolute" style="width: 75%; text-align: center; color: #ffffff; font-size: 16px; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        </div>
    </div>
</div>
